
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"transparent","d":"M10.4 2.2h5c.9 0 1.7.3 2.4 1 4.4 4.4 8.7 8.8 13.1 13.1 1 1 1.1 2.7.5 3.7-.1.2-.3.4-.5.6-3.4 3.4-6.9 6.8-10.3 10.3-1.2 1.2-3.2 1.2-4.3 0-4.4-4.4-8.8-8.8-13.1-13.2-.7-.7-1-1.4-.9-2.3V5.3c0-1.8 1.3-3 3.1-3 1.6-.1 3.3-.1 5-.1zm-1.5 9c1.2 0 2.2-1 2.2-2.2 0-1.3-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2-.1 1.2.9 2.2 2.2 2.2z","stroke":"#46aea6","stroke-width":"2.307","stroke-linejoin":"round","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M18.4 17.3c.3-.3.7-.6 1-1 .8-.8 1.7-1.2 2.8-1.2 1.8 0 3.5 1.5 3.6 3.3.1 1.2-.3 2.2-1.1 3-2.1 2.1-4.2 4.2-6.2 6.3l-.1.1-.1-.1-6.2-6.2c-1.2-1.2-1.4-3.3-.4-4.8 1.4-1.9 4.2-2.1 5.8-.4.3.3.6.7.9 1z","fill":"#f9aa1e"}})])
          )
        }
      }
    